import { Directive, ElementRef, HostBinding, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appTableCell]',
    standalone: false
})
export class  TableCellDirective implements OnInit {

  @Input() fxFlex = '';

  @HostBinding('class')
  className = 'app-table-cell';

  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    this.el.nativeElement.setAttribute('style', 'flex: 1 1 100' + this.fxFlex + '%');
  }
}
